import './scss/base.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import HTTP1 from './components/Http'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)

Vue.prototype.$authPage = false; //specified to show header or not
//Vue.prototype.$userName = "Allo Etot";

Vue.use(require('vue-moment'));
Vue.mixin({
  data: function () {
    return {
      get HTTP() { return HTTP1 },
      get userName() {
        let user = HTTP1.getUserProfile();
        if (user && user.name)
          return user.name;
        return "John Doe"
      },
      get userRole() {
        let user = HTTP1.getUserProfile();
        if (user && user.role)
          return user.role;
        return "readonly"
      }
    }
  },
  computed: {
    viewType: {
      get: function () {
        let vt = localStorage.getItem("viewType");
        return vt;
      },
      set: function (newValue) {
        localStorage.setItem("viewType", newValue);
      }
    },
    cardsCount: {
      get: function () {
        let cc = localStorage.getItem("cardsCount");
        return cc;
      },
      set: function (newValue) {
        localStorage.setItem("cardsCount", newValue);
      }
    },
    selectedProductId: {
      get: function () {
        let pid = localStorage.getItem("selectedProductId");
        return parseInt(pid);
      },
      set: function (newValue) {
        localStorage.setItem("selectedProductId", newValue);
      }
    },
    selectedVersionId: {
      get: function () {
        let vid = localStorage.getItem("selectedVersionId");
        return parseInt(vid);
      },
      set: function (newValue) {
        localStorage.setItem("selectedVersionId", newValue);
      }
    }
  }
})

const needAuth = () => {
  console.log(HTTP1);
  if (HTTP1.getToken()) {
    return false;
  }
  else
    return true;
};

router.beforeEach((to, from, next) => {
  if (to.path !== '/auth' && to.path !== '/callback') {

    HTTP1.getUser().then(function (user) {
      if (user !== null && !user.expired) {
        console.log("Got user!!!");
        console.log(user);
        Vue.prototype.$authPage = false;
        next();
      }
      else {
        console.log("user didn't received");
        Vue.prototype.$authPage = true;
        next('/auth');
      }
    });
    // if (!needAuth()) {
    //   console.log("Got token!!!");
    //   Vue.prototype.$authPage = false;
    //   next();
    // }
    // else {
    //   console.log("Token didn't received");
    //   Vue.prototype.$authPage = true;
    //   next('/auth');
    // }

  } else {
    Vue.prototype.$authPage = true;
    next();
  }
});




new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router
  //store
})



// WEBPACK FOOTER //
// ./src/main.js